<section>
    <div class="header">
        <h2>Modificar Garantía</h2>
    </div>
    <div class="modal-body">
        <form class="form-section" [formGroup]="formUpdate" (ngSubmit)="submit()">
            <div style="text-align: center;">
                <mat-form-field>
                    <mat-label>Es Construcción</mat-label>
                    <mat-select formControlName="state">
                        <mat-option *ngFor="let estado of estados"
                            [value]="estado.value">
                            {{estado.text}}
                        </mat-option>
                    </mat-select>    
                </mat-form-field> 
            </div>
            <div style="text-align: center;">
                <button [disabled]="!formUpdate.touched && formUpdate.invalid" type="submit" style="margin-top: 10px;" mat-raised-button color="primary">Actualizar</button>
            </div>
        </form>
    </div>
</section>